import React from 'react';
import Categorie from './Categorie';
import './categoriesStyle.css';

const categories = [
    { label: 'Development'},
    { label: 'Business'},
    { label: 'Marketing'},
];

const categorieContainer = (props) =>{
    return(
            <div className="sectionContainer">
                <h2 className="textAlign">Categories</h2>
                <div className="categorieContainer">
                {categories.map(ctrl => ( 
                <Categorie
                    key={ctrl.label} 
                    label={ctrl.label}
                    selected={() => props.categorieSelected(ctrl.label)}
                    link1={ctrl.link1}
                    link2={ctrl.link2}
                    link3={ctrl.link3}
                    link4={ctrl.link4}
                />
        ))}
        </div>
    </div>

    )
    
} 

export default categorieContainer;